import type { LoginActionState } from '@/app/(auth)/actions';

// Terse snake_case vocabulary for the `error` property of `Login Failed`.
// Detail goes in `error_message`/`error_details`. Keep in sync with the mobile
// counterpart at `pierre-mobile/src/features/analytics/utils/loginErrorCode.ts`.
export const LOGIN_ERROR_CODE = {
  invalid_credentials: 'invalid_credentials',
  invalid_data: 'invalid_data',
  infinitepay_auth_failed: 'infinitepay_auth_failed',
  session_expired: 'session_expired',
  server_error: 'server_error',
  network_error: 'network_error',
  social_auth_cancelled: 'social_auth_cancelled',
  social_auth_failed: 'social_auth_failed',
  unknown_error: 'unknown_error',
} as const;

export type LoginErrorCode =
  (typeof LOGIN_ERROR_CODE)[keyof typeof LOGIN_ERROR_CODE];

// Maps the login server-action status to a terse `error` code. The action only
// exposes `failed`/`invalid_data`, so anything else falls back to unknown_error.
export function loginErrorCodeFromStatus(
  status: LoginActionState['status'],
): LoginErrorCode {
  switch (status) {
    case 'failed':
      return LOGIN_ERROR_CODE.invalid_credentials;
    case 'invalid_data':
      return LOGIN_ERROR_CODE.invalid_data;
    default:
      return LOGIN_ERROR_CODE.unknown_error;
  }
}
